import type { IndexFiltersProps } from "@shopify/polaris";

export const defaultOrderedClosedPurchaseOrderSortValue = "created_at-asc";

export const purchaseOrderTableSortOptions = [
  { label: "Created", value: "created_at asc", directionLabel: "Oldest to newest" },
  { label: "Created", value: "created_at desc", directionLabel: "Newest to oldest" },
  { label: "Title", value: "product_title asc", directionLabel: "A–Z" },
  { label: "Title", value: "product_title desc", directionLabel: "Z–A" },
  { label: "SKU", value: "sku asc", directionLabel: "A–Z" },
  { label: "SKU", value: "sku desc", directionLabel: "Z–A" },
  { label: "Cost", value: "cost asc", directionLabel: "Low to high" },
  { label: "Cost", value: "cost desc", directionLabel: "High to low" },
  { label: "Quantity", value: "quantity asc", directionLabel: "Low to high" },
  { label: "Quantity", value: "quantity desc", directionLabel: "High to low" },
  { label: "Line total", value: "line_total asc", directionLabel: "Low to high" },
  { label: "Line total", value: "line_total desc", directionLabel: "High to low" },
] satisfies IndexFiltersProps["sortOptions"];
